import React from "react";
import { Calendar } from "primereact/calendar";
import {
  CALENDAR_DISPLAY_DATE_FORMAT,
  CALENDAR_LOCALE,
} from "../../utils/constants/calendar-constants";

interface RecurrenceFieldsProps {
  values: any;
  touched: any;
  errors: any;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  isDisabled: boolean;
}

export const RecurrenceFields = ({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  setFieldValue,
  isDisabled,
}: RecurrenceFieldsProps) => {
  return (
    <div className="grid col-12 my-2">
      <div className="col-12 md:col-6">
        <div className="flex gap-3 justify-content-end mt-2">
          {[
            { value: "daily", label: "Diario" },
            { value: "weekly", label: "Semanal" },
            { value: "monthly", label: "Mensual" },
          ].map((option) => (
            <div key={option.value} className="flex align-items-center">
              <input
                type="radio"
                id={option.value}
                name="recurrence"
                value={option.value}
                checked={values.recurrence === option.value}
                onChange={(e) => setFieldValue("recurrence", e.target.value)}
                disabled={isDisabled}
                className="p-radio-input"
                style={{ accentColor: 'var(--primary-color)' }}
              />
              <label htmlFor={option.value} className="ml-2 mr-3" style={{ fontSize: '1.25rem', }}>
                {option.label}
              </label>
            </div>
          ))}
        </div>
        {touched.recurrence && errors.recurrence && (
          <small className="p-error block mt-1">{errors.recurrence}</small>
        )}
      </div>

      <div className="col-12 md:col-6">
        <span className="p-float-label w-full">
          <Calendar
            id="endDate"
            name="endDate"
            value={values.endDate}
            onChange={(e) => setFieldValue("endDate", e.value)}
            onBlur={handleBlur}
            minDate={values.startDate}
            dateFormat={CALENDAR_DISPLAY_DATE_FORMAT}
            locale={CALENDAR_LOCALE}
            className={`w-full ${touched.endDate && errors.endDate ? "p-invalid" : ""} ${values.endDate ? "p-filled" : ""
              }`}
            disabled={isDisabled}
          />
          <label htmlFor="endDate">Fecha final de recurrencia</label>
        </span>
        {touched.endDate && errors.endDate && (
          <small className="p-error block mt-1">{errors.endDate}</small>
        )}
      </div>
    </div>
  );
};
